import { Layout } from '~/eds/src/components/Layout/Layout';

export const SIDEBAR_WIDTH = '320px';

type Props = {
  isExpanded: boolean;
};

export const TicketDetailsSidebar = ({ isExpanded }: Props) => {
  if (!isExpanded) {
    return null;
  }

  return (
    <Layout
      direction="column"
      bg="background.quiet"
      p={4}
      w={SIDEBAR_WIDTH}
      flex="0 0 auto"
    >
      Sidebar placeholder
    </Layout>
  );
};
